import { useCallback, useState } from "react";
import useHttp from "./useHttp";

export default function useAI() {
  const { fetchData } = useHttp();
  const [loading, setLoading] = useState(false);

  const generateContent = useCallback(
    async (prompt, integId, appProperties, options = {}) => {
      const { model = 2, tone = null } = options;

      if (!integId) {
        throw new Error("Integration ID is required for AI content generation");
      }

      let finalPrompt = prompt;
      if (tone) {
        finalPrompt = `${prompt} Generate in a ${tone.toLowerCase()} tone.`;
      }

      const payload = { prompt: finalPrompt };

      setLoading(true);
      try {
        const response = await fetchData(`ai/${integId}/content/generate?model=${model}`, "POST", payload, appProperties);

        const responseData = JSON.parse(response);
        const generatedContent = responseData?.data?.data?.trim();

        return {
          success: true,
          data: generatedContent,
          response: generatedContent, // For backward compatibility
        };
      } catch (error) {
        console.error("Error generating AI content:", error);
        return {
          success: false,
          error: error.message || "Failed to generate content",
        };
      } finally {
        setLoading(false);
      }
    },
    [fetchData]
  );

  return {
    generateContent,
    loading,
  };
}
